// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

export const selectBooking = ($) => $?.booking ?? null;
export const selectBookingAllDay = ($) => $?.booking?.allDay ?? null;
export const selectBookingAddedServices = ($) => $?.booking?.addedServices ?? null;
export const selectBookingAppointmentStartTimeList = ($) => $?.booking?.appointmentStartTimeList ?? null;
export const selectBookingCurrentStylistId = ($) => $?.booking?.currentStylistId ?? null;
export const selectBookingIsFetching = ($) => $?.booking?.isFetching ?? null;
export const selectBookingIsUnedited = ($) => $?.booking?.unedited ?? null;
export const selectBookingNewRebookCreated = ($) => $?.booking?.newRebookCreated;

export const selectBookingNewAppointment = ($) => $?.booking?.newAppointment;
export const selectBookingOldAppointment = ($) => $?.booking?.oldAppointment;
